export default __webpack_public_path__ + "15f26b5d041c0094eaf2766f042945bc.png";